import React from 'react';
import './style.scss';

export interface ISectionHeader {
    header: string; // 标题
    content: string; // 内容
    largeMargin?: boolean;
}

const SectionHeader: React.FC<ISectionHeader> = props => {
    const { header, content, largeMargin } = props;

    return (
        <section className={`section-header-root ${largeMargin ? 'margin-top' : ''}`}>
            <h1 className="platform-section-header">{header}</h1>
            <p className="platform-section-content">{content}</p>
        </section>
    );
};

export default SectionHeader;
